import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class WhatsappCampaignSettingsRecord extends RecordBase {
  static defaultAttributes = {
    template_name: '',
    template_language: 'pt_BR',
    header_video_url: '',
    send_hours: '8,12,17',
    batch_size: 50,
    min_days_since_signup: 7,
    is_enabled: false,
    has_api_token: false,
    env_api_token: false,
    send_enabled: true,
    run_requested_at: null,
    run_started_at: null,
    last_tick_at: null,
    last_run_at: null,
    last_run_slot: null,
    last_run_summary: null,
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`whatsappCampaign.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        template_name: trAttr('template_name'),
        template_language: trAttr('template_language'),
        header_video_url: trAttr('header_video_url'),
        send_hours: trAttr('send_hours'),
        batch_size: trAttr('batch_size'),
        min_days_since_signup: trAttr('min_days_since_signup'),
        is_enabled: trAttr('is_enabled'),
        last_tick_at: trAttr('last_tick_at'),
        last_run_at: trAttr('last_run_at'),
      };
    }
    return this._attributeNames;
  }

  toParams() {
    const {
      template_name,
      template_language,
      header_video_url,
      send_hours,
      batch_size,
      min_days_since_signup,
      is_enabled,
    } = this.toObject();
    const attributes = {
      template_name,
      template_language,
      header_video_url: header_video_url || '',
      send_hours,
      batch_size,
      min_days_since_signup,
      is_enabled,
    };
    return { data: { attributes } };
  }
}
